import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import BillDetail from 'saas/common/bill/BillDetail';
import _debug from 'debug';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import fetch from 'utils/fetch';
import moment from 'moment';
import Big from 'big.js';
import { displayConfirmModalIfNeeded } from '../emit/confirm-emission';

const debug = _debug('app::invoices');

require('plugins/forms');

const verifyRequiredFields = $form => {
  const $inputs = $form.find('input');
  let hasErrors = false;

  if ($inputs && $inputs.length) {
    $inputs.each((idx, elem) => {
      const $parentField = $(elem).parents('.required.field');
      if ($parentField && $parentField.length) {
        if (!$(elem).val()) {
          $parentField.addClass('error');
          hasErrors = true;
        } else {
          $parentField.removeClass('error');
        }
      }
    });
  }
  return !hasErrors;
};

const handleFormSubmission = linesComponent => {
  let nextAction, nextMethod;

  $('.actionBar button[type=submit]').on('click', function(evt) {
    evt.preventDefault();
    const $button = $(evt.target);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method') || 'PUT';

    nextAction = action;
    nextMethod = method;

    if ($button.hasClass('emission')) {
      const idStr = $('input[name=id]').val();
      const id = Number(idStr);
      displayConfirmModalIfNeeded([id], () =>
        $('section.bills form.mainForm').trigger('submit')
      );
    } else {
      $('section.bills form.mainForm').trigger('submit');
    }
  });

  $('section.bills form.mainForm').on('submit', evt => {
    evt.preventDefault();

    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;
    const method = $button.attr('data-method') || nextMethod || 'PUT';

    nextAction = null;
    nextMethod = null;

    const $form = $(evt.currentTarget);
    const data = {};

    verifyRequiredFields($form);

    for (let prop of $form.serializeArray()) {
      data[prop.name] = prop.value;
    }

    data['lines'] = linesComponent
      .getLines()
      .map((item, idx) => Object.assign({ order: idx + 1, ...item }));
    data['deletedIds'] = linesComponent.state.deletedIds;

    data['total_ht'] = $('.fullTotalHT').text();
    data['total_tva'] = linesComponent
      .getLines()
      .reduce((acc, curr) => acc.plus(curr.tva_amount), new Big(0))
      .toFixed(2);
    data['total_ttc'] = $('.fullTotalTTC').text();

    // Submitting
    const url = $form.attr('action');

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => {
        if (action && method) {
          return fetch(action, {
            method,
          });
        } else {
          return Promise.resolve(res);
        }
      })
      .then(
        res => {
          window.location.replace(res.url);
        },
        err => {
          console.log('Error attempting to save invoice', err);

          hideLoader();
          if (err.res.status === 412 || err.res.status === 409) {
            err.res.text().then(message => error(message));
          } else if (err.res.status === 400) {
            if (verifyRequiredFields($form)) {
              error(
                'Une erreur est survenue pendant la sauvegarde de la facture'
              );
            }
          } else {
            error(
              'Une erreur est survenue pendant la sauvegarde de la facture'
            );
          }
        }
      );

    return false;
  });
};

const setPaymentDate = (issueDate, modificationAllowed) => {
  if (issueDate) {
    $('#payment_date').val(issueDate.format('DD/MM/YYYY'));
  } else {
    $('#payment_date').val('');
  }

  if (modificationAllowed) {
    $('#payment_date')
      .removeClass('disabled')
      .removeClass('ui')
      .removeClass('field');
  } else {
    $('#payment_date')
      .addClass('disabled')
      .addClass('ui')
      .addClass('field');
  }
};

export const applyPaymentDelay = (
  mode,
  emission,
  overrideCustom = true,
  setPaymentDateFunc = setPaymentDate
) => {
  const emissionMoment = moment(emission, 'DD/MM/YYYY');
  let issueDate = undefined;
  if (mode === '30_DAYS') {
    if (emission) {
      issueDate = emissionMoment.add(30, 'days');
    }
    setPaymentDateFunc(issueDate, false);
  } else if (mode === '60_DAYS') {
    if (emission) {
      issueDate = emissionMoment.add(60, 'days');
    }
    setPaymentDateFunc(issueDate, false);
  } else if (mode === '30_DAYS_END_MONTH') {
    if (emission) {
      issueDate = emissionMoment.add(30, 'days').endOf('month');
    }
    setPaymentDateFunc(issueDate, false);
  } else if (mode === '45_DAYS_END_MONTH') {
    if (emission) {
      issueDate = emissionMoment.add(45, 'days').endOf('month');
    }
    setPaymentDateFunc(issueDate, false);
  } else if (mode === 'CUSTOM' && overrideCustom) {
    if (emission) {
      issueDate = emissionMoment.add(7, 'days');
    }
    setPaymentDateFunc(issueDate, true);
  }
};

export const checkPaymentDateRequirement = $delayInput => {
  const $paymentDateInput = $('#payment_date');
  const $paymentDateInputField = $paymentDateInput.parent('.field');

  if ($delayInput && $delayInput.val() === 'CUSTOM') {
    $paymentDateInputField.addClass('required');
  } else {
    $paymentDateInputField.removeClass('required');
  }
};

const handlePaymentDate = () => {
  const $input = $('#payment_delay');

  if ($input && $input.length) {
    checkPaymentDateRequirement($input);
    applyPaymentDelay($input.val(), $('#issue_date').val(), false);

    $input.on('change', evt => {
      evt.preventDefault();
      checkPaymentDateRequirement($(evt.target));
      applyPaymentDelay($(evt.target).val(), $('#issue_date').val());
    });
  }
};

const handleEmissionDate = () => {
  $('#issue_date').on('change', evt => {
    evt.preventDefault();
    applyPaymentDelay($('#payment_delay').val(), $(evt.target).val(), false);
  });
};

export default function bind() {
  const root = document.getElementById('bill');
  if (root) {
    debug(`Rendering bill detail for invoice`);

    // Retrieving context data
    let lines = __INITIAL_DATA__;
    if (!lines) {
      lines = [];
    }
    lines.map(line => {
      if (line.id) {
        return line;
      } else {
        delete line.id;
        return line;
      }
    });

    const { textBeforeLines, textAfterLines } = window.__MODEL_TEMPLATE__;

    const linesComponent = ReactDOM.render(
      <BillDetail
        lines={lines}
        textBeforeLines={textBeforeLines}
        textAfterLines={textAfterLines}
        readOnly={root.getAttribute('data-disabled') === 'true'}
      />,
      root
    );

    handleFormSubmission(linesComponent);
  }

  handlePaymentDate();
  handleEmissionDate();

  return null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/lines/index.js